import type { Context } from 'react';
import { use } from 'react';

import { QuickAddMenuContext } from './context';
import type { QuickActionResponseType, QuickAddMenuContextType } from './model';

export function useQuickAddMenuContext<T extends keyof QuickActionResponseType>() {
  const context = use(QuickAddMenuContext as Context<QuickAddMenuContextType<T>>);

  return context as QuickAddMenuContextType<T>;
}
